(function () {
  class FreespinsFireSlotManager extends PIXI.Container {
    constructor() {
      super();

      this._fireslots = [];
      this._fireballs = [];
      this._x2Panels = [];

      this._surrounds = [];

      this._activatedSlots = [];

      this._fsHighlightSnd = [
        "thunderballLand0",
        "thunderballLand1",
        "thunderballLand2",
      ];

      this._doSpinFunc = this.doSpin.bind(this);
      messageBus.subscribe(
        "spinner:GameConfigEvent",
        this.onGameConfigEvent.bind(this)
      );
      messageBus.subscribe("8bof:Demotions", this.onDemotionsEvent.bind(this));

      messageBus.subscribe(
        "spinner:FreeSpinsStartEvent",
        this.onFreespinsStartEvent.bind(this)
      );
      messageBus.subscribe(
        "spinner:FreeSpinsEndEvent",
        this.onFreespinsEndEvent.bind(this)
      );
    }

    onGameConfigEvent() {
      const self = this;
      const reelNames = ["reel0", "reel1", "reel2", "reel3", "reel4", "reel5"];
      gameController.slotMachine.subscribeToReelsLandedEvent(function (reelId) {
        const reel = reelNames.indexOf(reelId);
        self.onSpinLand(reel);
      });

      this._fireballLandAnimator = resourceManager.get(
        "slotContainer:FireballLandAnimator"
      );

      for (let reel = 0; reel < gameData.numReels; ++reel) {
        let reelSlots = [];
        let reelFireballs = [];
        for (let row = 0; row < gameData.numRows; ++row) {
          const fireslot = resourceManager.get(
            "slotContainer:freespinsFireSlots:fireslotManager:fireslot_" +
              reel +
              "_" +
              row +
              ":fireslot"
          );
          reelSlots.push(fireslot);
          const fireball = resourceManager.get(
            "slotContainer:freespinsFireSlots:fireslotManager:fireslotFireball_" +
              reel +
              "_" +
              row +
              ":fireball"
          );
          reelFireballs.push(fireball);
        }
        this._fireslots.push(reelSlots);
        this._fireballs.push(reelFireballs);

        const x2 = resourceManager.get(
          "slotContainer:x2Multipliers:x2Reel" + reel
        );
        x2.visible = false;
        const x2Copy = resourceManager.get(
          "slotContainer:x2Multipliers:x2Reel" + reel + "_copy"
        );
        x2Copy.visible = false;
        this._x2Panels.push({
          sprite: x2,
          copy: x2Copy,
          endPositions: [
            resourceManager.get(
              "slotContainer:x2Multipliers:x2Reel" + reel + "_RowPos0"
            ),
            resourceManager.get(
              "slotContainer:x2Multipliers:x2Reel" + reel + "_RowPos1"
            ),
            resourceManager.get(
              "slotContainer:x2Multipliers:x2Reel" + reel + "_RowPos2"
            ),
          ],
        });

        const x3Surround = resourceManager.get(
          "slotContainer:freespinsFireSlots:fireslotManager:fireslotX3Surrounds:x3Surround_" +
            reel
        );
        x3Surround.visible = false;

        const x2Surround_0 = resourceManager.get(
          "slotContainer:freespinsFireSlots:fireslotManager:fireslotX2Surrounds:x2Surround_" +
            reel +
            "_0"
        );
        x2Surround_0.visible = false;
        const x2Surround_1 = resourceManager.get(
          "slotContainer:freespinsFireSlots:fireslotManager:fireslotX2Surrounds:x2Surround_" +
            reel +
            "_1"
        );
        x2Surround_1.visible = false;

        this._surrounds.push({
          lockedRows: [false, false, false],
          x3Surround,
          x2Surrounds: [x2Surround_0, x2Surround_1],
        });
      }
    }

    onSpinLand(reel) {
      if (this._currentReelList) {
        let symbolsToAnimate = [];

        for (
          let row = 0;
          row < this._currentReelList[reel].symbols.length;
          ++row
        ) {
          const found = this._activatedSlots.find(function (slot) {
            return slot.reel === reel && slot.row === row;
          });

          if (found) {
            const symbolId = this._currentReelList[reel].symbols[row].value;
            if (gameController.symbolIsFireball(symbolId)) {
              symbolsToAnimate.push({
                cell: { reel: reel, row: row },
                symbolId: symbolId,
              });
            }
          }
        }

        if (symbolsToAnimate.length > 0) {
          let soundIndex = Math.floor(
            Math.random() * this._fsHighlightSnd.length
          );
          soundManager.play(this._fsHighlightSnd[soundIndex]);
        }

        this._fireballLandAnimator.animateSymbols(
          symbolsToAnimate,
          gameController.slotMachine,
          true,
          true,
          function () {}
        );
      }
    }

    animateX2(reel, row, callback) {
      soundManager.play("electricBuzz");

      this._x2Panels[reel].copy.visible = true;
      this._x2Panels[reel].copy.position.setY(
        layoutController.getCurrentPosition(this._x2Panels[reel].copy.Props.FQN)
          .y
      );

      let time = 600 - 150 * row;
      const self = this;
      timerManager.addTimer(
        time,
        function (progress) {
          const startY = layoutController.getCurrentPosition(
            self._x2Panels[reel].copy.Props.FQN
          ).y;
          const endY = self._x2Panels[reel].endPositions[row].position.getY();

          const yDist = (endY - startY) * progress;

          self._x2Panels[reel].copy.position.setY(startY + yDist);
        },
        function () {
          const startY = layoutController.getCurrentPosition(
            self._x2Panels[reel].copy.Props.FQN
          ).y;
          self._x2Panels[reel].copy.position.setY(startY);
          self._x2Panels[reel].copy.visible = false;
          callback();
        }
      );
    }

    setx2PanelAlpha(alpha) {
      for (let i = 0; i < this._x2Panels.length; i++) {
        this._x2Panels[i].sprite.alpha = alpha;
      }
    }

    onFreespinsStartEvent() {
      this._activatedSlots = [];
      messageBus.subscribe("spinner:SpinEvent", this._doSpinFunc);
    }

    onFreespinsEndEvent() {
      this._currentReelList = undefined;
      messageBus.unsubscribe("spinner:SpinEvent", this._doSpinFunc);
      this._fireslots.forEach(function (reelFireballs) {
        reelFireballs.forEach(function (rowFireball) {
          rowFireball.reset();
        });
      });
      this._x2Panels.forEach(function (panel) {
        panel.sprite.visible = false;
      });
      this._surrounds.forEach(function (surroundInfo) {
        surroundInfo.x3Surround.visible = false;
        for (let row = 0; row < gameData.numRows; ++row) {
          surroundInfo.lockedRows[row] = false;
        }
        surroundInfo.x2Surrounds.forEach(function (x2Surround) {
          x2Surround.visible = false;
        });
      });
    }

    doSpin(task) {
      this._spinTask = task;
      this._spinTask.join();
      this._currentReelList = this._spinTask.data.resultPanel.reelList;
      this._activationIndex = 0;
      this.fireNextActivationFireball();

      soundManager.play("thunder");
      soundManager.play("lightningPunch");
    }

    fireNextActivationFireball() {
      const self = this;

      const reel =
        this._spinTask.data.newActivations[this._activationIndex].reel;
      const row = this._spinTask.data.newActivations[this._activationIndex].row;

      this._activatedSlots.push({ reel, row });

      game.thunderAnim.play(0);

      gameController.lightningStriking = true;

      soundManager.play("lightning" + this._activationIndex);

      const state = 2;
      this._fireballs[reel][row].animate(function () {
        self.activationChange([{ reel, row, state }], function () {});
      });
      ++this._activationIndex;

      if (this._activationIndex >= this._spinTask.data.newActivations.length) {
        this._spinTask.leave();
        this._spinTask = undefined;

        timerManager.addTimeout(1700, function () {
          gameController.lightningStriking = false;
          self.stopAllLightning();
        });
      } else {
        timerManager.addTimeout(400, function () {
          self.fireNextActivationFireball();
        });
      }
    }

    stopAllLightning() {
      this._fireballs.forEach((fireballArray) => {
        fireballArray.forEach((fireball) => {
          fireball.stopLightning();
        });
      });
    }

    onDemotionsEvent(task) {
      if (task.data.demotions.length > 0) {
        task.join();
      }
      let count = task.data.demotions.length;
      const self = this;
      task.data.demotions.forEach(function (demotion) {
        const reel = demotion.coord.reel;
        const row = demotion.coord.row;
        const state = demotion.newState;
        if (state === 0) {
          const found = self._activatedSlots.find(function (slot) {
            return slot.reel === reel && slot.row === row;
          });
          if (found) {
            const index = self._activatedSlots.indexOf(found);
            self._activatedSlots.splice(index, 1);
          }
        }
        self._fireslots[reel][row].activationChange(state, function () {
          --count;
          if (count <= 0) {
            task.leave();
          }
        });
      });
    }

    pulseX2(reel) {
      this._x2Panels[reel].sprite.visible = true;
      const self = this;
      timerManager.addTimer(
        500,
        function (progress) {
          const scale = InterpolationHelper.interpolateSine(1, 1.5, progress);
          self._x2Panels[reel].sprite.scale.set(scale, scale);
        },
        function () {
          self._x2Panels[reel].sprite.scale.set(1, 1);
        }
      );
    }

    processSurroundChanges(reel) {
      // plays sound in each case as this can be called when none of them apply
      if (
        this._surrounds[reel].lockedRows[0] &&
        this._surrounds[reel].lockedRows[1] &&
        this._surrounds[reel].lockedRows[2]
      ) {
        this._surrounds[reel].x2Surrounds[0].visible = false;
        this._surrounds[reel].x2Surrounds[1].visible = false;
        this._surrounds[reel].x3Surround.visible = true;
        this.pulseX2(reel);

        soundManager.play("x2Active");

        this._fireslots[reel].forEach(function (fireslot) {
          fireslot.removeSurround();
        });
      } else if (
        this._surrounds[reel].lockedRows[0] &&
        this._surrounds[reel].lockedRows[1]
      ) {
        this._surrounds[reel].x2Surrounds[0].visible = true;
        this._surrounds[reel].x2Surrounds[1].visible = false;
        this._surrounds[reel].x3Surround.visible = false;
        this._fireslots[reel][0].removeSurround();
        this._fireslots[reel][1].removeSurround();
      } else if (
        this._surrounds[reel].lockedRows[1] &&
        this._surrounds[reel].lockedRows[2]
      ) {
        this._surrounds[reel].x2Surrounds[0].visible = false;
        this._surrounds[reel].x2Surrounds[1].visible = true;
        this._surrounds[reel].x3Surround.visible = false;
        this._fireslots[reel][1].removeSurround();
        this._fireslots[reel][2].removeSurround();
      }
    }

    activationChange(slots, callback) {
      let count = slots.length;
      const self = this;

      slots.forEach(function (slot) {
        self._fireslots[slot.reel][slot.row].activationChange(
          slot.state,
          function () {
            if (slot.state === 3) {
              self._surrounds[slot.reel].lockedRows[slot.row] = true;
              self.processSurroundChanges(slot.reel);
            }

            --count;
            if (count <= 0) {
              callback();
            }
          }
        );
      });
    }
  }

  var creator = function (json) {
    return new FreespinsFireSlotManager();
  };

  var initialiser = function (json, freespinsFireSlotManager) {};

  var filesRequired = function () {
    return ["freespins/Hammer_Prize_Box.png"];
  };

  resourceManager.registerObjectType(
    "freespinsFireSlotManager",
    creator,
    initialiser,
    filesRequired
  );
})();
